export const physiotherapyCityPaths = [
  "/physiotherapy/bangalore/",
  "/physiotherapy/delhi-ncr/",
  "/physiotherapy/mumbai/",
  "/physiotherapy/hyderabad/",
  "/physiotherapy/chennai/",
  "/physiotherapy/pune/",
  "/physiotherapy/gurgaon/",
  "/physiotherapy/kolkata/",
  "/physiotherapy/ghaziabad/",
  "/physiotherapy/indore/",
  "/physiotherapy/lucknow/",
  "/physiotherapy/ahmedabad/",
  "/physiotherapy/jaipur/",
  "/physiotherapy/noida/",
  "/physiotherapy/salem/",
  "/physiotherapy/chandigarh/",
  "/physiotherapy/howrah/",
  "/physiotherapy/ludhiana/",
  "/physiotherapy/nagpur/",
  "/physiotherapy/faridabad/",
];

// Convert absolute URLs to path-only versions
export const physiotherapyTreatmentPaths = [
  "/physiotherapy/online-physiotherapy-service/",
  "/physiotherapy/physiotherapy-for-varicose-veins/",
  "/physiotherapy/supraspinatus-tendinitis/",
  "/physiotherapy/electrotherapy-in-physiotherapy/",
  "/physiotherapy/physiotherapy-for-weight-loss/",
  "/physiotherapy/neurological-physiotherapy/",
  "/physiotherapy/foot-care/",
  "/physiotherapy/ultrasound-physiotherapy/",
  "/physiotherapy/paralysis-treatment/",
  "/physiotherapy/cerebral-atrophy/",
  "/physiotherapy/physiotherapy-clinics/",
  "/physiotherapy/spondylosis/",
  "/physiotherapy/gouty-arthritis/",
  "/physiotherapy/calcaneal-spur/",
  "/physiotherapy/physiotherapy-for-traction/",
  "/physiotherapy/genu-valgum/",
  "/physiotherapy/pediatric-physiotherapy/",
  "/physiotherapy/infrared-physiotherapy/",
  "/physiotherapy/stroke/",
  "/physiotherapy/sports-injury-treatment/",
  "/physiotherapy/elbow-pain/",
  "/physiotherapy/vocal-cord-paralysis/",
  "/physiotherapy/chest-physiotherapy/",
  "/physiotherapy/achilles-tendinitis/",
  "/physiotherapy/cervical-radiopathy/",
];

export const physiotherapyConditionPaths = [
  "/physiotherapy/retrolisthesis/",
  "/physiotherapy/lumbar-spondylosis/",
  "/physiotherapy/monoparesis/",
  "/physiotherapy/hemiparesis/",
  "/physiotherapy/iliopsoas-bursitis/",
  "/physiotherapy/ligament-laxity/",
  "/physiotherapy/meningitis/",
  "/physiotherapy/monoplegia/",
  "/physiotherapy/shoulder-hand-syndrome/",
  "/physiotherapy/ctev/",
];

export const toTitleCase = (text) =>
  (text || "")
    .toLowerCase()
    .replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const getLastSlug = (urlOrPath) =>
  (urlOrPath || "").replace(/\/$/, "").split("/").filter(Boolean).pop();
